<div class="lotes-page">
  <ng-container *ngIf="!loteSelecionado; else detalheLote">
    <div class="page-heading">
      <div>
        <span class="eyebrow">Administração</span>
        <h1>Lotes de conferência</h1>
        <p>Abra ciclos de reconferência e acompanhe o histórico de cada município.</p>
      </div>
      <div class="heading-actions">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="abrirModalConfiguracao(modalConfiguracao)">
          <i class="fa fa-cog mr-1"></i> Configurar conferência
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="abrirModalNovoLote(modalNovoLote)">
          <i class="fa fa-plus mr-1"></i> Abrir novo lote
        </button>
      </div>
    </div>

    <div class="overview-grid">
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-play"></i></span>
        <div><strong>{{ lotesAtivos }}</strong><span>Lotes ativos</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-check"></i></span>
        <div><strong>{{ lotesFechados }}</strong><span>Lotes encerrados</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-percent"></i></span>
        <div><strong>{{ progressoLoteAtivo }}%</strong><span>Progresso do lote ativo</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-ellipsis-h"></i></span>
        <div><strong>{{ conferenciasEmAberto }}</strong><span>Conferências em aberto</span></div>
      </div>
    </div>

    <div class="card filtros-card">
      <div class="card-body">
        <div class="form-row align-items-end">
          <div class="col-md-5">
            <label>Município</label>
            <ng-select
              [items]="municipios"
              bindLabel="nome"
              bindValue="id"
              [(ngModel)]="filtroCidade"
              placeholder="Todos os municípios">
            </ng-select>
          </div>
          <div class="col-md-4 mt-3 mt-md-0">
            <label>Situação</label>
            <select class="form-control" [(ngModel)]="filtroStatus">
              <option value="">Todos os status</option>
              <option value="aberto">Abertos</option>
              <option value="fechado">Encerrados</option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mt-md-0">
            <button class="btn btn-outline-primary btn-block" (click)="carregarLotes()" [disabled]="carregandoLotes">
              <i class="fa fa-search mr-1"></i> Pesquisar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card lotes-table-card">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Lote</th>
              <th>Município</th>
              <th>Situação</th>
              <th>Modo</th>
              <th>Escopo</th>
              <th>Progresso</th>
              <th>Abertura / fechamento</th>
              <th>Versão</th>
              <th class="text-right">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let lote of lotes">
              <td>
                <strong>{{ lote.nome }}</strong>
                <small class="d-block text-muted">#LC-{{ lote.id }}</small>
              </td>
              <td>{{ lote.nome_cidade }}</td>
              <td>
                <span class="status-pill" [class.aberto]="lote.status === 'aberto'">{{ rotuloStatus(lote.status) }}</span>
              </td>
              <td>
                <span class="mode-pill" [class.por-meta]="lote.modo_distribuicao === 'POR_META'">
                  {{ rotuloModo(lote.modo_distribuicao) }}
                </span>
                <small
                  class="d-block text-warning"
                  *ngIf="lote.status === 'aberto' && lote.modo_distribuicao === 'POR_META' && lote.pendentes_sem_atribuicao > 0">
                  {{ lote.pendentes_sem_atribuicao }} aguardando distribuição
                </small>
              </td>
              <td>
                <strong>{{ lote.total_servidores || lote.total_conferencias || 0 }}</strong> servidores
                <small class="d-block text-muted">{{ lote.total_matriculas || 0 }} matrículas</small>
              </td>
              <td class="progress-cell">
                <div class="progress progress-sm">
                  <div class="progress-bar" [style.width.%]="lote.percentual_concluido || 0"></div>
                </div>
                <strong>{{ lote.percentual_concluido || 0 }}%</strong>
              </td>
              <td>
                {{ formatarData(lote.data_abertura) }}
                <small class="d-block text-muted" *ngIf="lote.data_fechamento">encerrado em {{ formatarData(lote.data_fechamento) }}</small>
                <small class="d-block text-muted" *ngIf="!lote.data_fechamento">em andamento</small>
              </td>
              <td><span class="version-pill">v{{ lote.versao }}</span></td>
              <td class="text-right">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="selecionarLote(lote)">
                  {{ lote.status === 'aberto' ? 'Acompanhar' : 'Ver detalhes' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!carregandoLotes && !lotes.length">
              <td colspan="9" class="empty-state">Nenhum lote encontrado.</td>
            </tr>
            <tr *ngIf="carregandoLotes">
              <td colspan="9" class="empty-state">Carregando lotes...</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer">Exibindo {{ lotes.length }} lote(s)</div>
    </div>
  </ng-container>

  <ng-template #detalheLote>
    <div class="detail-heading">
      <div>
        <button type="button" class="back-link" (click)="voltarParaLotes()">
          <i class="fa fa-angle-left mr-1"></i> Lotes de conferência
        </button>
        <div class="d-flex flex-wrap align-items-center">
          <h1>{{ loteSelecionado.nome }}</h1>
          <span class="status-pill ml-2" [class.aberto]="loteSelecionado.status === 'aberto'">{{ rotuloStatus(loteSelecionado.status) }}</span>
          <span class="mode-pill ml-2" [class.por-meta]="loteSelecionado.modo_distribuicao === 'POR_META'">
            {{ rotuloModo(loteSelecionado.modo_distribuicao) }}
          </span>
        </div>
        <p>{{ loteSelecionado.nome_cidade }} · versão v{{ loteSelecionado.versao }} · aberto em {{ formatarData(loteSelecionado.data_abertura) }}</p>
      </div>
      <div class="actions">
        <button class="btn btn-outline-primary" (click)="abrirModalDistribuicao(modalDistribuicao)">
          <i class="fa fa-random mr-1"></i> Distribuição
        </button>
        <button class="btn btn-outline-primary" (click)="gerarPdf()">
          <i class="fa fa-file-pdf-o mr-1"></i> Exportar PDF
        </button>
        <button *ngIf="loteSelecionado.status === 'aberto'" class="btn btn-danger" (click)="fecharLote()">
          <i class="fa fa-lock mr-1"></i> Encerrar lote
        </button>
      </div>
    </div>

    <div class="card progress-feature">
      <div>
        <strong>{{ loteSelecionado.conferidas || 0 }} de {{ loteSelecionado.total_servidores || loteSelecionado.total_conferencias || 0 }} servidores concluídos</strong>
        <small>{{ conferenciasPendentesLote }} ainda exigem ação</small>
      </div>
      <div class="progress-feature-bar">
        <div class="progress">
          <div class="progress-bar" [style.width.%]="loteSelecionado.percentual_concluido || 0"></div>
        </div>
        <strong>{{ loteSelecionado.percentual_concluido || 0 }}% do lote</strong>
      </div>
    </div>

    <div class="overview-grid detail-metrics">
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-list"></i></span>
        <div><strong>{{ loteSelecionado.total_servidores || loteSelecionado.total_conferencias || 0 }}</strong><span>Servidores no lote</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-check"></i></span>
        <div><strong>{{ loteSelecionado.conferidas || 0 }}</strong><span>Conferidas</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-refresh"></i></span>
        <div><strong>{{ loteSelecionado.em_conferencia || 0 }}</strong><span>Em conferência</span></div>
      </div>
      <div class="metric-card">
        <span class="metric-icon"><i class="fa fa-ellipsis-h"></i></span>
        <div><strong>{{ loteSelecionado.pendentes || 0 }}</strong><span>Pendentes</span></div>
      </div>
    </div>

    <div class="card desempenho-card">
      <div class="card-header-clean">
        <div>
          <h4>Progresso por conferidor</h4>
          <p>Percentual concluído sobre os servidores distribuídos ou assumidos por cada conferidor.</p>
        </div>
        <button class="btn btn-sm btn-outline-primary" (click)="abrirModalDistribuicao(modalDistribuicao)" *ngIf="loteSelecionado.status === 'aberto'">
          Ajustar distribuição
        </button>
      </div>
      <div class="fila-livre-banner" *ngIf="loteSelecionado.modo_distribuicao === 'FILA_LIVRE'">
        <i class="fa fa-users" aria-hidden="true"></i>
        <div>
          <strong>Fila livre</strong>
          <span>Os servidores sem responsável ficam disponíveis para todos os conferidores. {{ distribuicao.resumo.pendentes_sem_atribuicao }} permanecem pendentes sem conferidor.</span>
        </div>
      </div>
      <div class="meta-pendente-banner" *ngIf="loteSelecionado.modo_distribuicao === 'POR_META' && loteSelecionado.pendentes_sem_atribuicao > 0">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <div>
          <strong>Distribuição incompleta</strong>
          <span>{{ loteSelecionado.pendentes_sem_atribuicao }} servidores ainda não estão visíveis para nenhum conferidor.</span>
        </div>
      </div>
      <div class="conferidores-grid" *ngIf="progressoPorConferidor.length; else semConferidores">
        <div class="conferidor-progress" *ngFor="let item of progressoPorConferidor">
          <div class="conferidor-title">
            <div>
              <strong>{{ item.nome_conferidor }}</strong>
              <small>{{ item.conferidas }} de {{ item.total_atribuido }} concluídas</small>
            </div>
            <strong>{{ item.percentual }}%</strong>
          </div>
          <div class="progress progress-sm">
            <div class="progress-bar" [style.width.%]="item.percentual"></div>
          </div>
          <div class="conferidor-meta">
            <span>{{ item.em_conferencia }} em conferência</span>
            <span>{{ item.pendentes }} pendentes</span>
          </div>
        </div>
      </div>
      <ng-template #semConferidores>
        <div class="empty-state" *ngIf="loteSelecionado.modo_distribuicao === 'POR_META'; else filaSemAssumidos">
          Faça a distribuição para liberar os servidores aos conferidores.
        </div>
        <ng-template #filaSemAssumidos>
          <div class="empty-state">Nenhum conferidor assumiu servidores desta fila ainda.</div>
        </ng-template>
      </ng-template>
    </div>

    <div class="card servidores-card">
      <div class="card-header-clean">
        <div>
          <h4>Servidores do lote</h4>
          <p>Consulte as matrículas e filtre por situação ou conferidor.</p>
        </div>
      </div>
      <div class="servidores-filtros">
        <div class="form-row align-items-end">
          <div class="col-lg-5">
            <label>Servidor, CPF ou matrícula</label>
            <input class="form-control" [(ngModel)]="buscaConferencia" (keyup.enter)="filtrarConferencias()" placeholder="Digite para pesquisar">
          </div>
          <div class="col-lg-3 mt-3 mt-lg-0">
            <label>Situação</label>
            <select class="form-control" [(ngModel)]="situacaoConferencia">
              <option value="">Todas</option>
              <option value="pendente">Pendente</option>
              <option value="em_conferencia">Em conferência</option>
              <option value="conferido">Conferido</option>
            </select>
          </div>
          <div class="col-lg-3 mt-3 mt-lg-0">
            <label>Conferidor</label>
            <select class="form-control" [(ngModel)]="filtroConferidor">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let item of progressoPorConferidor" [ngValue]="item.id_conferidor">{{ item.nome_conferidor }}</option>
            </select>
          </div>
          <div class="col-lg-1 mt-3 mt-lg-0">
            <button class="btn btn-outline-primary btn-block" (click)="filtrarConferencias()" title="Pesquisar">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Servidor</th>
              <th>Matrículas</th>
              <th>Situação</th>
              <th>Conferidor</th>
              <th class="text-right">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of conferencias">
              <td>
                <strong>{{ item.nome_servidor }}</strong>
                <small class="d-block text-muted">{{ item.cpf || '-' }}</small>
              </td>
              <td>
                <strong>{{ item.quantidade_matriculas || 0 }}</strong>
                <small class="d-block text-muted">{{ item.matricula || '-' }}</small>
              </td>
              <td><span class="situacao situacao-{{ item.situacao }}">{{ rotuloSituacao(item.situacao) }}</span></td>
              <td>{{ item.nome_conferidor || 'Não atribuído' }}</td>
              <td class="text-right">
                <button
                  *ngIf="loteSelecionado.status === 'aberto' && item.situacao !== 'pendente'"
                  class="btn btn-sm btn-outline-danger"
                  (click)="resetarConferencia(item)"
                  title="Enviar para reconferência">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!carregandoConferencias && !conferencias.length">
              <td colspan="5" class="empty-state">Nenhuma conferência encontrada.</td>
            </tr>
            <tr *ngIf="carregandoConferencias">
              <td colspan="5" class="empty-state">Carregando servidores...</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer pagination-footer" *ngIf="totalConferencias">
        <span>{{ (paginaConferencias - 1) * tamanhoPagina + 1 }}–{{ Math.min(paginaConferencias * tamanhoPagina, totalConferencias) }} de {{ totalConferencias }}</span>
        <div>
          <button class="btn btn-sm btn-outline-secondary mr-1" (click)="mudarPagina(-1)" [disabled]="paginaConferencias === 1">Anterior</button>
          <button class="btn btn-sm btn-outline-secondary" (click)="mudarPagina(1)" [disabled]="paginaConferencias * tamanhoPagina >= totalConferencias">Próxima</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #modalConfiguracao let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title">Configurar conferência</h4>
      <small>Defina por município se a conferência será controlada por lotes.</small>
    </div>
    <button type="button" class="close" aria-label="Fechar" [disabled]="salvandoConfiguracao" (click)="modal.dismiss('fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-0">
      <label>Município</label>
      <ng-select
        class="mode-city-select"
        [items]="municipios"
        bindLabel="nome"
        bindValue="id"
        [loading]="municipiosLoading"
        [(ngModel)]="municipioConfiguracao"
        (change)="carregarConfiguracao()"
        (search)="onMunicipioSearch($event)"
        (scrollToEnd)="onMunicipioScrollToEnd()"
        placeholder="Selecione o município">
      </ng-select>
    </div>

    <div *ngIf="!municipioConfiguracao" class="alert alert-info mt-3 mb-0">
      Selecione um município para consultar ou alterar o modo de conferência.
    </div>

    <div *ngIf="municipioConfiguracao" class="configuration-status mt-3">
      <div *ngIf="carregandoConfiguracao" class="configuration-loading">
        <i class="fa fa-spinner fa-spin mr-2"></i> Consultando configuração...
      </div>
      <ng-container *ngIf="configuracaoCarregada && !carregandoConfiguracao">
        <div>
          <span class="eyebrow">Situação atual</span>
          <h5>{{ conferenciaPorLote ? 'Conferência por lote ativada' : 'Conferência por lote desativada' }}</h5>
          <p *ngIf="conferenciaPorLote">
            A conferência exige lote aberto, que pode operar em fila livre ou por distribuição.
          </p>
          <p *ngIf="!conferenciaPorLote">
            Os conferidores visualizam todos os servidores disponíveis e não dependem de lote aberto.
          </p>
        </div>
        <button
          type="button"
          class="mode-toggle"
          [class.active]="conferenciaPorLote"
          [disabled]="salvandoConfiguracao"
          [attr.aria-pressed]="conferenciaPorLote"
          (click)="alterarConferenciaPorLote()">
          <span></span>
          {{ salvandoConfiguracao ? 'Salvando...' : (conferenciaPorLote ? 'Ativada' : 'Desativada') }}
        </button>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" [disabled]="salvandoConfiguracao" (click)="modal.close('concluir')">Fechar</button>
  </div>
</ng-template>

<ng-template #modalNovoLote let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title">Abrir novo lote</h4>
      <small>Crie uma nova rodada de conferência para um município.</small>
    </div>
    <button type="button" class="close" aria-label="Fechar" [disabled]="abrindo" (click)="modal.dismiss('fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [attr.aria-busy]="abrindo">
    <div class="lote-opening-loading" *ngIf="abrindo">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <strong>Abrindo o lote de conferência...</strong>
      <span>Estamos identificando os servidores aptos e criando uma linha de auditoria para cada matrícula. Aguarde.</span>
    </div>
    <ng-container *ngIf="!abrindo">
      <div class="alert alert-info">
        A abertura inclui os vínculos ativos cujo atendimento já foi finalizado. Só pode existir um lote aberto por município.
      </div>
      <div class="form-group">
        <label>Município</label>
        <ng-select
          [items]="municipios"
          bindLabel="nome"
          bindValue="id"
          [loading]="municipiosLoading"
          [(ngModel)]="novoLote.id_cidade"
          (change)="onMunicipioNovoLoteChange()"
          (search)="onMunicipioSearch($event)"
          (scrollToEnd)="onMunicipioScrollToEnd()"
          placeholder="Selecione o município">
        </ng-select>
        <small *ngIf="carregandoConfiguracaoNovoLote" class="text-muted d-block mt-1">
          Consultando a configuração do município...
        </small>
        <div *ngIf="novoLote.id_cidade && novoLoteConferenciaPorLote === false" class="alert alert-warning mt-2 mb-0">
          A conferência por lote está desativada neste município. Use o botão “Configurar conferência” antes de abrir o lote.
        </div>
        <div *ngIf="novoLoteConferenciaPorLote === true" class="alert alert-success mt-2 mb-0">
          Conferência por lote ativada para o município selecionado.
        </div>
      </div>
      <div class="form-group">
        <label>Nome do lote</label>
        <input class="form-control" [(ngModel)]="novoLote.nome" maxlength="150" placeholder="Ex.: Reconferência 2026">
      </div>
      <div class="form-group">
        <label>Modo de trabalho</label>
        <div class="mode-options">
          <label class="mode-option" [class.selected]="novoLote.modo_distribuicao === 'FILA_LIVRE'">
            <input type="radio" name="modoDistribuicao" [(ngModel)]="novoLote.modo_distribuicao" value="FILA_LIVRE">
            <span>
              <strong>Fila livre</strong>
              <small>Todos os conferidores do município veem os pendentes. O primeiro que iniciar assume o servidor.</small>
            </span>
          </label>
          <label class="mode-option" [class.selected]="novoLote.modo_distribuicao === 'POR_META'">
            <input type="radio" name="modoDistribuicao" [(ngModel)]="novoLote.modo_distribuicao" value="POR_META">
            <span>
              <strong>Por distribuição</strong>
              <small>Você define quantidades por conferidor e cada um vê apenas os servidores atribuídos a ele.</small>
            </span>
          </label>
        </div>
      </div>
      <div class="form-group mb-0">
        <label>Observação</label>
        <textarea class="form-control" [(ngModel)]="novoLote.observacoes" maxlength="500" rows="3" placeholder="Opcional"></textarea>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" [disabled]="abrindo" (click)="modal.dismiss('cancelar')">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="abrindo || carregandoConfiguracaoNovoLote || novoLoteConferenciaPorLote !== true || !novoLote.id_cidade || !novoLote.nome" (click)="abrirLote(modal)">
      <span *ngIf="!abrindo"><i class="fa fa-plus mr-1"></i> Abrir lote</span>
      <span *ngIf="abrindo"><i class="fa fa-spinner fa-spin mr-1"></i> Abrindo lote...</span>
    </button>
  </div>
</ng-template>

<ng-template #modalDistribuicao let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title">Distribuição de servidores</h4>
      <small *ngIf="loteSelecionado">
        {{ loteSelecionado.nome_cidade }} · Lote {{ loteSelecionado.versao }} · {{ loteSelecionado.nome }}
      </small>
    </div>
    <button type="button" class="close" aria-label="Fechar" [disabled]="salvandoDistribuicao || removendoDistribuicao" (click)="modal.dismiss('fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="distribuicao">
    <div class="alert alert-info">
      Os servidores são sorteados entre os conferidores. Todas as matrículas do mesmo servidor permanecem com o mesmo responsável. Em uma redistribuição, somente os servidores pendentes podem mudar.
    </div>
    <div class="alert alert-warning" *ngIf="!distribuicao.resumo.tem_distribuicao">
      <strong>Este lote está em fila livre.</strong> Sem distribuição, todos visualizam os servidores ainda sem responsável e o vínculo de todas as suas matrículas ocorre quando a conferência é iniciada.
    </div>
    <div class="alert alert-warning" *ngIf="loteSelecionado.modo_distribuicao === 'POR_META' && distribuicao.resumo.pendentes_sem_atribuicao > 0">
      <strong>Distribuição pendente.</strong> Os conferidores só poderão visualizar servidores depois que a distribuição for salva.
    </div>

    <div class="distribuicao-resumo" [class.invalido]="!distribuicaoValida">
      <div><span>Planejado</span><strong>{{ totalPlanejadoDistribuicao }}</strong></div>
      <div><span>Total do lote</span><strong>{{ totalLoteDistribuicao }}</strong></div>
      <div><span>Restante</span><strong>{{ totalLoteDistribuicao - totalPlanejadoDistribuicao }}</strong></div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <small class="text-muted">A quantidade mínima corresponde ao que já foi iniciado ou concluído.</small>
      <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="loteSelecionado && loteSelecionado.status === 'aberto'" (click)="dividirIgualmente()">
        <i class="fa fa-balance-scale mr-1"></i> Dividir igualmente
      </button>
    </div>

    <div class="table-responsive distribuicao-tabela">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Conferidor</th>
            <th class="text-center">Já realizadas</th>
            <th class="text-center">Pendentes atuais</th>
            <th class="quantidade-col">Servidores no lote</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of distribuicao.conferidores" [class.text-muted]="!item.disponivel">
            <td>
              <strong>{{ item.nome_conferidor }}</strong>
              <small class="d-block">{{ item.login_conferidor }}</small>
              <small class="d-block text-danger" *ngIf="!item.disponivel">Vínculo inativo — somente histórico</small>
            </td>
            <td class="text-center">{{ item.quantidade_minima }}</td>
            <td class="text-center">{{ item.pendentes }}</td>
            <td>
              <input
                type="number"
                class="form-control text-center"
                [(ngModel)]="item.quantidade_planejada"
                (change)="ajustarQuantidade(item)"
                [min]="item.quantidade_minima"
                [disabled]="!item.disponivel || !loteSelecionado || loteSelecionado.status !== 'aberto'">
              <small class="text-muted">mín. {{ item.quantidade_minima }}</small>
            </td>
          </tr>
          <tr *ngIf="!distribuicao.conferidores.length">
            <td colspan="4" class="text-center text-muted py-4">Nenhum conferidor vinculado ao município.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-warning mr-auto"
      *ngIf="loteSelecionado && loteSelecionado.status === 'aberto' && loteSelecionado.modo_distribuicao === 'POR_META'"
      [disabled]="salvandoDistribuicao || removendoDistribuicao"
      (click)="usarFilaLivre(modal)">
      <i class="fa fa-users mr-1"></i> Usar fila livre
    </button>
    <button type="button" class="btn btn-outline-secondary" [disabled]="salvandoDistribuicao || removendoDistribuicao" (click)="modal.dismiss('cancelar')">Cancelar</button>
    <button
      type="button"
      class="btn btn-primary"
      *ngIf="loteSelecionado && loteSelecionado.status === 'aberto'"
      [disabled]="!distribuicaoValida || salvandoDistribuicao || removendoDistribuicao"
      (click)="salvarDistribuicao(modal)">
      <i class="fa fa-random mr-1"></i> Sortear e salvar
    </button>
  </div>
</ng-template>

